export default "__VITE_ASSET__DtTk43aD__"